import FileInput from "../common/FileInput";
import FieldNote from "./common/FieldNote";

export default function WebsiteMediaInput({ label, type = "image", field, record, setRecord, disabled, hint }) {
    return (
        <div>
            <FileInput
                className="mt-4"
                label={label}
                type={type}
                cdn_url={record?.[field] || ""}
                setCDNUrl={(cdn_url) => setRecord((prev) => ({ ...prev, [field]: cdn_url }))}
                disabled={disabled}
            />
            <FieldNote text={hint} />
        </div>
    );
}
